import { RoleName } from "consts/auth";
import { WebRoutes } from "consts/enpoints/web";
import routes from "consts/routes";

export type PermissionRole = {
    readonly roleName: RoleName;
    readonly label: string;
};

export type PermissionSection = {
    readonly key: string;
    readonly label: string;
    readonly description: string;
    readonly roles: Array<RoleName>;
};

/**
 * Roles a Merchant Admin can assign (mirrors management-api RolesController@listByMerchant).
 */
export const permissionRoles: Array<PermissionRole> = [
    {
        roleName: RoleName.MerchantAdmin,
        label: 'Merchant Admin'
    },
    {
        roleName: RoleName.MerchantFinance,
        label: 'Merchant Finance'
    },
    {
        roleName: RoleName.MerchantTech,
        label: 'Merchant Tech / Support'
    },
    {
        roleName: RoleName.MerchantEmployee,
        label: 'Merchant Employee'
    }
];

/**
 * Access is derived from consts/routes so the matrix always matches the real route guards.
 */
export const permissionSections: Array<PermissionSection> = [
    {
        key: 'home',
        label: 'Home',
        description: 'Overview and eCommerce platform setup',
        roles: routes[WebRoutes.Root].roles
    },
    {
        key: 'dashboard',
        label: 'Dashboard',
        description: 'Statistics and charts',
        roles: routes[WebRoutes.Dashboard].roles
    },
    {
        key: 'transactions',
        label: 'Transactions',
        description: 'Transaction list, refunds and status checks',
        roles: routes[WebRoutes.Transactions].roles
    },
    {
        key: 'consumersWhitelist',
        label: 'Consumers - Whitelist Import',
        description: 'Import and review whitelisted consumer emails',
        roles: routes[WebRoutes.Consumers.WhiteListed].roles
    },
    {
        key: 'paymentMethods',
        label: 'Payment Methods',
        description: 'Payment methods enabled for the merchant',
        roles: routes[WebRoutes.PaymentMethods].roles
    },
    {
        key: 'finance',
        label: 'Finance',
        description: 'Settlements and monthly summary files',
        roles: routes[WebRoutes.Finance.Index].roles
    },
    {
        key: 'profile',
        label: 'Profile',
        description: 'Merchant profile details',
        roles: routes[WebRoutes.Profile].roles
    },
    {
        key: 'users',
        label: 'Users',
        description: 'Create and manage portal users',
        roles: routes[WebRoutes.Users].roles
    },
    {
        key: 'support',
        label: 'Support',
        description: 'Contact the Macropay support team',
        roles: routes[WebRoutes.Support].roles
    },
    {
        key: 'documentation',
        label: 'Documentation',
        description: 'API documentation',
        roles: routes[WebRoutes.Documentation].roles
    }
];

// An empty role list means every authenticated portal user is authorized (see consts/routes).
export const hasAccess = (section: PermissionSection, roleName: RoleName) =>
    !section.roles.length || section.roles.includes(roleName);
